export const messages = {
  open_until: {
    defaultMessage: 'Open until',
    id: 'nemo.ui.dealer-context.opening-hours.open-text-fragment',
  },
  closed_fragment: {
    defaultMessage: 'Closed, opens',
    id: 'nemo.ui.dealer-context.opening-hours.closed-text-fragment',
  },
  today: {
    defaultMessage: 'Today at',
    id: 'nemo.ui.dealer-context.opening-hours.today-text-fragment',
  },
  time_format: {
    defaultMessage: 'h',
    id: 'nemo.ui.dealer-context.opening-hours.time-format',
  },
  dealership_connected_notification: {
    defaultMessage: 'You are now connected to this dealer.',
    id: 'nemo.ui.dealer-context.connected-dealership-notification',
  },
  dealership_select_button: {
    defaultMessage: 'Select dealer',
    id: 'nemo.ui.dealer-context.connect-dealership-select-button',
  },
  dealership_select_button_aria: {
    defaultMessage: 'Open dealer search',
    id: 'nemo.ui.dealer-context.connect-dealership-select-button-aria',
  },
  dealership_close_select_button_aria: {
    defaultMessage: 'Close dealer search',
    id: 'nemo.ui.dealer-context.connect-dealership-close-select-button-aria',
  },
  dealership_connect_heading: {
    defaultMessage: 'Connect with a dealership',
    id: 'nemo.ui.dealer-context.connect-dealership-heading',
  },
  dealership_connect_body: {
    defaultMessage:
      'Get information on stock car inventory or special offers tailored to your needs across the website!<br /><br /> The connected dealer will be your personal contact for offer requests, test drive bookings, or finance & leasing information.',
    id: 'nemo.ui.dealer-context.connect-dealership-body',
  },
  dealership_connect_button: {
    defaultMessage: 'Find a dealer',
    id: 'nemo.ui.dealer-context.connect-dealership-button',
  },
  dealer_label: {
    defaultMessage: 'Connected to:',
    id: 'nemo.ui.dealer-context.label',
  },
  dealer_information: {
    defaultMessage: 'Open dealer information',
    id: 'nemo.ui.dealer-context.dealer-information-aria',
  },
  dealer_information_close: {
    defaultMessage: 'Close dealer information',
    id: 'nemo.ui.dealer-context.dealer-information-close-aria',
  },
  dealer_info: {
    defaultMessage: 'show additional dealer info',
    id: 'nemo.ui.dealer-context.show-additional-dealer-data',
  },
  hide_dealer_info: {
    defaultMessage: 'hide additional dealer info',
    id: 'nemo.ui.dealer-context.hide-additional-dealer-data',
  },
  back_to_dealer: {
    defaultMessage: 'Back to dealer',
    id: 'nemo.ui.dealer-context.back-button-text',
  },
  visit_dealer: {
    defaultMessage: 'Visit dealer website',
    id: 'nemo.ui.dealer-context.visit-button-text',
  },
  remove_dealer: {
    defaultMessage: 'Disconnect from dealer',
    id: 'nemo.ui.dealer-context.remove-dealer-label',
  },
  remove_dealer_help: {
    defaultMessage:
      'By forgetting this dealer, your dealer connection will be removed from the header. To visit this or another dealership, visit the store locator.',
    id: 'nemo.ui.dealer-context.remove-dealer-help-text',
  },
  sales: {
    defaultMessage: '',
    id: 'nemo.ui.dealer-context.sales-text',
  },
  sales_r8: {
    defaultMessage: '',
    id: 'nemo.ui.dealer-context.sales-r8-text',
  },
  service_r8: {
    defaultMessage: '',
    id: 'nemo.ui.dealer-context.service-r8-text',
  },
  service: {
    defaultMessage: '',
    id: 'nemo.ui.dealer-context.service-text',
  },
  service_no_agent: {
    defaultMessage: '',
    id: 'nemo.ui.dealer-context.service-noagent-text',
  },
  etron: {
    defaultMessage: '',
    id: 'nemo.ui.dealer-context.etron-text',
  },
  usedcars: {
    defaultMessage: '',
    id: 'nemo.ui.dealer-context.usedcars-text',
  },
  aftersales: {
    defaultMessage: '',
    id: 'nemo.ui.dealer-context.aftersales-text',
  },
  accident_specialist: {
    defaultMessage: '',
    id: 'nemo.ui.dealer-context.accident-specialist-text',
  },
  atyourdoor: {
    defaultMessage: '',
    id: 'nemo.ui.dealer-context.atyourdoor-text',
  },
  silver_car_by_audi: {
    defaultMessage: '',
    id: 'nemo.ui.dealer-context.silver-car-by-audi-text',
  },
  ovt: {
    defaultMessage: '',
    id: 'nemo.ui.dealer-context.ovt-text',
  },
  audi_on_demand: {
    defaultMessage: '',
    id: 'nemo.ui.dealer-context.audi-on-demand-text',
  },
};
